import { WelcomeContain, WelcomeDescription, WelcomeTitle, OfflineIcon } from './Welcome.styles';

import Images from 'src/App/Images';
import { useAppSelector } from 'src/App/redux/hooks';
import { RootState } from 'src/App/redux/store';

export function Offline() {
	const platform = useAppSelector((state: RootState) => state.app.platform);

	return (
		<WelcomeContain platform={platform}>
			<Images.GrayLogo />
			<Images.GrayLogo />
			<Images.GrayLogo />
			<Images.GrayLogo />

			<WelcomeTitle>
				Streamer is
				<br />
				Offline
			</WelcomeTitle>
			<OfflineIcon>
				<Images.Offline />
			</OfflineIcon>
			<WelcomeDescription>Check back soon...</WelcomeDescription>
		</WelcomeContain>
	);
}
